import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

interface SubscribeResponse {
  success: boolean;
  subscriptionId?: string;
  error?: string;
}
import { environment } from 'src/environments/environment';

interface SetupIntentResponse {
  clientSecret: string;
}

interface SubscriptionResponse {
  success: boolean;
  subscriptionId?: string;
  error?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  getCompanyList() {
    return this.http.get<any>(`${environment.apiUrl}/company/v1`);
  }

  createNewCompany(data) {
    return this.http.post<any>(`${environment.apiUrl}/company/v1`, data);
  }

  updateCompany(data) {
    return this.http.put<any>(`${environment.apiUrl}/company/v1`, data);
  }
  deleteCompany(id) {
    return this.http.delete<any>(`${environment.apiUrl}/company/v1/${id}`);
  }

  createUser(data) {
    return this.http.post<any>(`${environment.apiUrl}/auth/v1/signup`, data);
  }

  getUserList(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/auth/v1/users/list`,
      data
    );
  }

  updateUser(data) {
    return this.http.put<any>(`${environment.apiUrl}/auth/v1/user/roles`, data);
  }

  getbmList() {
    let data = {};
    return this.http.post<any>(
      `${environment.apiUrl}/boardmember/v1/list`,
      data
    );
  }

  createBoardMember(data) {
    return this.http.post<any>(`${environment.apiUrl}/boardmember/v1`, data);
  }

  deleteBM(id) {
    return this.http.delete<any>(`${environment.apiUrl}/boardmember/v1/${id}`);
  }

  updateBoardMember(data) {
    return this.http.post<any>(`${environment.apiUrl}/boardmember/v1`, data);
  }

  getBMInfo(id) {
    return this.http.get<any>(`${environment.apiUrl}/boardmember/v1/${id}`);
  }

  getGroupList() {
    return this.http.get<any>(`${environment.apiUrl}/group/v1`);
  }

  createGroup(data) {
    return this.http.post<any>(`${environment.apiUrl}/group/v1`, data);
  }

  deleteGroup(id) {
    return this.http.delete<any>(`${environment.apiUrl}/group/v1/${id}`);
  }

  updateGroup(data) {
    return this.http.put<any>(`${environment.apiUrl}/group/v1`, data);
  }

  getGroupSpecificBMList(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/groupmapping/v1/list`,
      data
    );
  }

  addBoardMemberToGroup(data) {
    return this.http.post<any>(`${environment.apiUrl}/groupmapping/v1`, data);
  }

  removeBoardMemberFromGroup(id) {
    return this.http.delete<any>(`${environment.apiUrl}/groupmapping/v1/${id}`);
  }

  createNewPoll(data) {
    return this.http.post<any>(`${environment.apiUrl}/polls/v1`, data);
  }

  addPollOptions(data) {
    return this.http.post<any>(`${environment.apiUrl}/polloptions/v1`, data);
  }

  updatePollOptions(data) {
    return this.http.put<any>(`${environment.apiUrl}/polloptions/v1`, data);
  }

  getPollOptionList(id) {
    return this.http.get<any>(`${environment.apiUrl}/polloptions/v1/${id}`);
  }

  updatePolls(data) {
    return this.http.put<any>(`${environment.apiUrl}/polls/v1`, data);
  }

  getPollList() {
    return this.http.get<any>(`${environment.apiUrl}/polls/v1/list`);
  }

  getSpecificPollInfo(id) {
    return this.http.get<any>(`${environment.apiUrl}/polls/v1/${id}`);
  }
  getPollExecutionHistory(id) {
    return this.http.get<any>(
      `${environment.apiUrl}/polls/v1/execute/list/${id}`
    );
  }

  companyInfo() {
    return this.http.get<any>(`${environment.apiUrl}/company/v1/fetch`);
  }

  deletePoll(id) {
    return this.http.delete<any>(`${environment.apiUrl}/polls/v1/${id}`);
  }

  executePoll(data) {
    return this.http.post<any>(`${environment.apiUrl}/polls/v1/execute`, data);
  }

  deletePollExecutionbyID(id) {
    return this.http.delete<any>(
      `${environment.apiUrl}/polls/v1/execute/${id}`
    );
  }

  getPollResultInfo(id) {
    return this.http.get<any>(`${environment.apiUrl}/polls/v1/results/${id}`);
  }

  pollResultsList(id) {
    return this.http.get<any>(
      `${environment.apiUrl}/polls/v1/results/list/${id}`
    );
  }

  cpmpletePollExecution(id) {
    let body = {};
    return this.http.put<any>(
      `${environment.apiUrl}/polls/v1/execute/complete/${id}`,
      body
    );
    // return this.http.get<any>(`${environment.apiUrl}/polls/v1/execute/${id}`);
  }

  deleteUser(id) {
    return this.http.delete<any>(`${environment.apiUrl}/auth/v1/user/${id}`);
  }

  updateUserName(data) {
    return this.http.put<any>(`${environment.apiUrl}/auth/v1/user`, data);
  }

  manualUpdatePollResult(data, id) {
    return this.http.put<any>(
      `${environment.apiUrl}/polls/v1/results/${id}`,
      data
    );
  }

  startLivePollVoteing(id) {
    return this.http.put<any>(
      `${environment.apiUrl}/polls/v1/execute/live_poll/${id}`,
      {}
    );
  }

  sendReminder(id) {
    return this.http.post<any>(
      `${environment.apiUrl}/polls/v1/execute/nudge/${id}`,
      {}
    );
  }

  bulkUpdatePollsWithGroup(data) {
    return this.http.put<any>(`${environment.apiUrl}/polls/v1/batch`, data);
  }

  clonePoll(id, name) {
    return this.http.post<any>(`${environment.apiUrl}/polls/v1/clone`, {
      poll_id: id,
      name: name,
    });
  }

  cloneGroup(id, name) {
    return this.http.post<any>(`${environment.apiUrl}/group/v1/clone`, {
      group_id: id,
      name: name,
    });
  }

  getPollInfoByUID(uid) {
    return this.http.get<any>(
      `${environment.apiUrl}/polls/v1/ranked-choice/${uid}`
    );
  }

  submitVote(uid, data) {
    return this.http.post<any>(
      `${environment.apiUrl}/polls/v1/ranked-choice/${uid}`,
      data
    );
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('authToken');
    console.log('Retrieved token for request:', token);
    if (!token) {
      console.error('No token found in localStorage');
    }
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token || ''}`,
      }),
    };
  }

  // ! New oode for onboarding process

  startOnboarding(payload: {
    company_name: string;
    email: string;
    phone: string;
  }): Observable<any> {
    return this.http.post(`${environment.apiUrl}/onboarding/v1/start`, payload);
  }

  updateOnboardingData(
    customerId: string,
    data: { company_name: string; phone: string }
  ): Observable<any> {
    return this.http.put(
      `${environment.apiUrl}/onboarding/v1/update/${customerId}`,
      data
    );
  }

  submitOnboardingData(customerID: string, data: any): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/onboarding/v1/submit/${customerID}`,
      data
    );
  }

  getOnboardingStatus(customerID: string): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/onboarding/v1/status/${customerID}`
    );
  }

  submitVerificationCode(customerID: string, code: string): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/onboarding/v1/verify/${customerID}`,
      { code }
    );
  }

  // ! New code for onboarding process save-draft

  saveFormData(
    customerId: string,
    formStep: number,
    formData: any
  ): Observable<any> {
    const payload = {
      customer_id: customerId,
      form_step: formStep,
      form_data: formData,
    };
    return this.http.post(
      `${environment.apiUrl}/onboarding-draft/v1/save/${customerId}`,
      payload
    );
  }

  getFormData(customerId: string): Observable<any> {
    console.log('Fetching form data for customerId:', customerId);
    return this.http.get(
      `${environment.apiUrl}/onboarding-draft/v1/get/${customerId}`
    );
  }

  clearFormData(customerId: string): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/onboarding-draft/v1/clear/${customerId}`,
      {}
    );
  }


    submitSelectedUseCase(customerId: string, selectedUseCase: string, campaignDetails?: any): Observable<any> {
    const payload = { selected_use_case: selectedUseCase, ...campaignDetails };
    return this.http.post(`${environment.apiUrl}/onboarding/v1/usecase/${customerId}`, payload);
  }

  getUseCases(customerId: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/onboarding/v1/usecases/${customerId}`);
  }

}
